// src/api/endpoints.js
const endpoints = {
  getCreateUser: "/v1/user/login",
  getUserInfo: "/v1/user/info",
  getGameList: "/v1/game/list",
  loginOut: "/v1/user/login_out",
  getCurrencyList: "/v1/currency/list",
  getWheelList: "/v1/wheel/list",
  postCreateSpin: "/v1/spin/create",
  postConfirmSpin: "/v1/spin/confirm",
  taskList: "/v1/task/list",
  createTask: "/v1/event/create",
  eventTask: "/v1/event/list",
  eventConfirm: "/v1/event/confirm",
  textToImage: "/v1/text_to_image",
  textToImageStatus: "/v1/text_to_image/status",
  imgUpload: "/v1/upload/image",
  imgToVideo: "/v1/image_to_video",
  imgToVideoStatus: "/v1/image_to_video/status",
  chatgpt: "/v1/smart_assistant",
};

export default endpoints;
